<ion-header class="ion-no-border">

    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (click)="close()">
                <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
            </ion-button>
        </ion-buttons>
		<ion-title>
            Add fulfillment
            <p *ngIf="order" class="subtitle">Order #{{order.number}}</p>
        </ion-title>
        <ion-buttons *ngIf="online && !loading" slot="end">
            <ion-button (click)="add()">
                <fa-icon [icon]="['far', 'check']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>

</ion-header>

<ion-content>

    <ion-grid *ngIf="online && !loading && order" class="form">

        <ion-row *ngIf="order_payment_owing || customer_amount_owing || customer_credit_limit_exceeded">
            <ion-col>
                <div class="warning-box">
                    <p *ngIf="order_payment_owing">There is <strong>{{order.currency.sign}}{{order.amount_due | number:'1.2'}} {{order.currency.code}}</strong> left to be paid on this order.</p>
                    <p *ngIf="customer_amount_owing">
                        <span *ngIf="order.organisation">The customer currently owes you <strong>{{base_currency.sign}}{{order.organisation.amount_owing | number:'1.2'}} {{order.currency.code}}</strong>.</span>
                        <span *ngIf="!order.organisation">The customer currently owes you <strong>{{base_currency.sign}}{{order.person.amount_owing | number:'1.2'}} {{order.currency.code}}</strong>.</span>
                    </p>
                    <p *ngIf="customer_credit_limit_exceeded">
                        <span *ngIf="order.organisation">The customer has exceeded their credit limit of <strong>{{base_currency.sign}}{{order.organisation.credit_limit | number:'1.2'}} {{order.currency.code}}</strong>.</span>
                        <span *ngIf="!order.organisation">The customer has exceeded their credit limit of <strong>{{base_currency.sign}}{{order.person.credit_limit | number:'1.2'}} {{order.currency.code}}</strong>.</span>
                    </p>
                </div>
            </ion-col>
        </ion-row>

        <ion-row>
            <ion-col>
                <ion-grid class="fieldset">
                    <ion-row>
                        <ion-col>
                            <h3>Items to fulfill</h3>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-grid class="ion-no-padding">
                                <ng-container *ngFor="let item of fulfillable_items">
                                    <ion-row *ngIf="item.fulfillable_quantity > 0" class="quantity-row">
                                        <ion-col>
                                            <ion-grid class="ion-no-padding">
                                                <ion-row>
                                                    <ion-col size="auto">
                                                        <h5>Item</h5>
                                                        <p class="prominent">{{item.title}}</p>
                                                    </ion-col>
                                                </ion-row>
                                                <ion-row *ngIf="item.sku">
                                                    <ion-col size="auto">
                                                        <h5>SKU</h5>
                                                        <p class="prominent">{{item.sku}}</p>
                                                    </ion-col>
                                                </ion-row>
                                                <ion-row *ngIf="item.track_stock">
                                                    <ion-col size="auto">
                                                        <h5>Stock on hand</h5>
                                                        <p class="badges ion-text-wrap">
                                                            <ion-badge *ngIf="item.stock_on_hand == 0" color="danger">{{item.stock_on_hand}}</ion-badge>
                                                            <ion-badge *ngIf="item.stock_on_hand != 0 && item.fulfillable_quantity > item.stock_on_hand" color="warning">{{item.stock_on_hand}}</ion-badge>
                                                            <ion-badge *ngIf="item.stock_on_hand >= item.fulfillable_quantity" color="success">{{item.stock_on_hand}}</ion-badge>
                                                        </p>
                                                    </ion-col>
                                                </ion-row>
                                            </ion-grid>
                                        </ion-col>
                                        <ion-col size="auto" class="ion-text-center">
                                            <div>
                                                <h5>Quantity<ng-container *ngIf="item.measurement_unit"> ({{item.measurement_unit.symbol}})</ng-container></h5>
                                                <fa-icon size="lg" [icon]="['fas', 'minus']" (click)="adjustItemQuantity(item.id,'subtract')"></fa-icon>
                                                <span>{{item.quantity}}</span> of {{item.fulfillable_quantity}}
                                                <fa-icon size="lg" [icon]="['fas', 'plus']" (click)="adjustItemQuantity(item.id,'add')"></fa-icon>
                                            </div>
                                        </ion-col>
                                    </ion-row>
                                </ng-container>
                            </ion-grid>
                        </ion-col>
                    </ion-row>
                    <ion-row *ngIf="(printer_paper_sizes && printer_paper_sizes.includes('a4')) && fulfillable_items.length != 0">
                        <ion-col>
                            <p><a (click)="printPackingSlip()" style="cursor: pointer;"><fa-icon [icon]="['fal', 'print']"></fa-icon>Print packing slip</a></p>
                        </ion-col>
                    </ion-row>
                </ion-grid>
                <ion-grid class="fieldset">
                    <ion-row *ngIf="order.special_instructions">
                        <ion-col>
                            <h5>Special instructions</h5>
                            <p class="prominent">{{order.special_instructions}}</p>
                        </ion-col>
                    </ion-row>
                    <ion-row *ngIf="order.gift_message">
                        <ion-col>
                            <h5>Gift message</h5>
                            <p class="prominent">{{order.gift_message}}</p>
                        </ion-col>
                    </ion-row>
                    <!-- TODO: put in address, mobile, courier instructions here -->
                    <ion-row *ngIf="order.shipping_rate">
                        <ion-col>
                            <h5>Shipping rate</h5>
                            <p class="prominent">{{order.shipping_rate.title}}</p>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <h5>Gift</h5>
                            <p class="prominent" *ngIf="order.gift == true">Yes</p>
                            <p class="prominent" *ngIf="order.gift == false">No</p>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-select cancelText="Clear" okText="OK" (ionCancel)="clearCourier()" interface="alert" [interfaceOptions]="courier_select_options" labelPlacement="stacked" fill="outline" [(ngModel)]="fulfillment_params['courier_id']">
                                <div slot="label">Courier<ion-text class="optional">optional</ion-text></div>
                                <ion-select-option *ngFor="let courier of couriers" value="{{courier.id}}">{{courier.title}}</ion-select-option>
                            </ion-select>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-input type="tel" inputmode="decimal" maxlength="100" labelPlacement="stacked" fill="outline" [(ngModel)]="fulfillment_params['courier_tracking_number']">
                                <div slot="label">Courier tracking number<ion-text class="optional">optional</ion-text></div>
                            </ion-input>
                        </ion-col>
                    </ion-row>
                </ion-grid>
                <ion-grid class="fieldset" *ngIf="order.person && order.person.email_address">
                    <ion-row *ngIf="order.shipping_notification_email_address">
                        <ion-col>
                            <div class="warning-box">
                                <p>A shipping notification email address has been provided for this order. The "order shipped" email will be sent to this address. Be aware that this may not be to the person who placed the order.</p>
                            </div>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <h5>Person</h5>
                            <p class="prominent" *ngIf="order.person.full_name">{{order.person.full_name}} (#{{order.person.number}})</p>
                            <p class="prominent" *ngIf="!order.person.full_name">#{{order.person.number}}</p>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <h5>Order count</h5>
                            <p class="prominent">{{order.person.order_count}}</p>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-textarea type="text" inputmode="text" maxlength="1000" [autoGrow]="true" rows="5" labelPlacement="stacked" fill="outline" [(ngModel)]="fulfillment_params['customer_note']">
                                <div slot="label">Note to customer<ion-text class="optional">optional</ion-text></div>
                            </ion-textarea>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-item lines="none" class="ion-no-padding">
                                <ion-toggle class="form-toogle" alignment="start" label-placement="stacked" [(ngModel)]="fulfillment_params.send_order_shipped_email">Send order shipped email</ion-toggle>
                            </ion-item>
                        </ion-col>
                    </ion-row>
                </ion-grid>
                <ion-grid class="fieldset">
                    <ion-row >
                        <ion-col>
                            <ion-input *ngIf="fulfillment_params['date']" class="modal-input" readonly="true" label="Date" labelPlacement="stacked" fill="outline" value={{formatted_date}} (click)="presentDateTimePickerModal()"></ion-input>
                            <ion-input *ngIf="!fulfillment_params['date']" class="modal-input" readonly="true" label="Date" labelPlacement="stacked" fill="outline" (click)="presentDateTimePickerModal()"></ion-input>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </ion-col>
        </ion-row>
    </ion-grid>
    
</ion-content>